<template>
	<div class="tw-mt-2 tw-flex tw-flex-col tw-space-y-2">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'DocumentList',
}
</script>